function getFocusableElements(container) {
  if (!container) return;
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  if (!elements) return;
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".cart-quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".cart-quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    } 
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class ScrollingBanner extends HTMLElement {
  constructor() {
    super();

    this.content = this.querySelector('[data-scrolling-banner-content]');
    this.speed = 500;
    this.hoverSpeed = 150;
    this.lastTime = Date.now();
    this.x = 0;
    this.repeat = 0;
    this.offset = 0;
    this.eventListeners = {};
    this.resizeTimeout;

    this.setup();
    this.resize();
    this.bindEvents();
    this.render();
  }

  bindEvents() {
    this.eventListeners = {
      resize: () => {
        if(this.resizeTimeout){
            clearTimeout(this.resizeTimeout) 
        }
        this.resizeTimeout = setTimeout(() => {
            this.resize()
        }, 3000);
        this.resize()},
      visibility: (e) => this.lastTime = Date.now(),
      mouseenter: () => this.hover = true,
      mouseleave: () => this.hover = false
    };

    window.addEventListener('resize', this.eventListeners.resize);
    document.addEventListener('visibilitychange', this.eventListeners.visibility); // Pauses the delta time

    

  }

  setup() {
    this.sizeItems();

    this.container = document.createElement('div');
    this.container.style.position = 'relative';
    this.container.style.display = 'flex';
    
    this.insertBefore(this.container, this.content);
    this.container.appendChild(this.content);

    this.x = this.content.offsetWidth * (this.offset / 100);
  }

  sizeItems() {
    if (this.content.getAttribute('data-content-count')) {
      const contentCount = this.content.getAttribute('data-content-count');
      const itemWidth = this.content.offsetWidth;
      const containerWidth = this.offsetWidth;
      const requiredWidth = containerWidth / contentCount;
      const paddingToSet = requiredWidth - itemWidth;
      const preSetContentPadding = parseInt(this.content.style.paddingRight.split('rem')[0] * 10);

      if (paddingToSet > preSetContentPadding) {
        this.content.style.paddingRight = `${paddingToSet}px`;
      }
    }
  }

  resize() {
    const previousRepeat = this.repeat;
    this.repeat = Math.ceil(window.innerWidth / this.content.offsetWidth);
    
    if(previousRepeat == this.repeat){
        return;
    }
    
    this.container.childNodes.forEach((node) => {
        if (!node.isSameNode(this.content)) {
            node.remove();
        }
    });
    
    if (this.repeat === NaN || this.repeat === Infinity) return; // Catch for Shopify theme editor bad calculations
    
    for (let i = 0; i < this.repeat; i++) {
        const clone = this.content.cloneNode(true);
        
        this.content.parentNode.insertBefore(clone, this.content.nextSibling);
    }
    
    const resizeEvent = new CustomEvent('scroll-banner-resize');
    document.dispatchEvent(resizeEvent);
  }

  render() {
    const time = Date.now();
    this.currentSpeed = this.hover ? Math.max(this.currentSpeed / 1.03, this.hoverSpeed) : this.speed;
    this.x += (time - this.lastTime) * (this.currentSpeed / 6000);
    this.lastTime = time;

    if (this.x >= this.content.offsetWidth) {
      this.x = 0;
    }

    this.container.style.transform = `translateX(-${this.x}px)`;

    requestAnimationFrame(() => this.render());
  }

}

customElements.define('scrolling-banner', ScrollingBanner);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.drawerButton = document.querySelector('[data-menu-drawer-button]')
    
    this.drawerButton.addEventListener('click', this.toggle.bind(this))
  }

  toggle() {
    
    this.classList.toggle('active');
    document.body.classList.toggle('overflow-hidden');
    
    if (this.classList.contains('active')) {
      document.querySelector('.header__nav-button').textContent = 'Close';
    } else {
      document.querySelector('.header__nav-button').textContent = 'Menu';
    }
  }
}

customElements.define('menu-drawer', MenuDrawer);

class SizeChart extends HTMLElement {
  constructor() {
    super();
    this.sizeChartButtons = document.querySelectorAll('[data-size-chart-button]');
    this.closeButton = this.querySelector('[data-size-chart-close]');
    
    this.sizeChartButtons.forEach(sizeChartButton => {
      sizeChartButton.addEventListener('click', this.show.bind(this));
    })

    this.closeButton.addEventListener('click', this.close.bind(this));
  }

  show() {
    this.classList.add('active');
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('size-chart', SizeChart);
